import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Post        from '@common/post/_post';
// -------------------------------------------------------

class SummaryCheckDraft extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    
    let none_insight = [];
    try {
      data.report.list.map((d) => {
        let diff = Moment().diff( Moment(d.post_date), 'days');
        if( data.project.detail.insight_wait_date < diff ){
          if( d.insight.length == 0 ) none_insight.push(d);
        }
      });
    } catch(e) {}
    
    return (
      <div className="summary-check-insight">
        <h2 className="summary-column">インサイト未提出 ({none_insight.length})</h2>
        
        <div className="insight-list">
          <ul>
            { none_insight.map((d, key) => {
              let account = {};
              try { account = data.workflow.influencers[d.insta_user_id]; } catch(e) {}
              
              return (
                <li key={key}>
                  <Post data={d} base={data} account={account} report={d} />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryCheckDraft;